module.exports = __webpack_public_path__ + "static/media/bicycle.9f0219ab.svg";